import { API } from "src/api/request";

// api.add_resource(
//   Info_RegisterIDResource,
//   "/71300/register/<_id>",
//   (methods = ["GET", "PUT", "DELETE"])
// );

export async function Reference(params) {
  const response = await API().get("/accident/reference", {
    params: { ...params },
  });
  return response.data;
}

export async function ReferenceType(id) {
  const response = await API().get("/inspection/referencetype/" + id);
  return response.data;
}

/**
 * Өндөр эрсдэлтэй АЖЛЫН ТӨРЛИЙН лавлах.
 *
 * `Inspection.ReferenceType` дотроос «Өндөр эрсдэлтэй ажлын төрөл» нэртэйг
 * олж, түүний `Reference` мөрүүдийг буцаана. Лавлах нь migration-аар
 * үүсгэгдэнэ (Models/highrisk/alter_highrisk_permit.sql) — байхгүй бол
 * хоосон массив буцаана, маягт хуучин хэвээр ажиллана.
 *
 * ⚠ `/inspection/referencetype` нь id ХҮЛЭЭЖ АВДАГГҮЙ (бүх төрлийг буцаана).
 */
const JOB_TYPE_REF_NAME = "Өндөр эрсдэлтэй ажлын төрөл";

export async function getHighRiskJobTypes() {
  try {
    const types = (await API().get("/inspection/referencetype")).data;
    const found = (Array.isArray(types) ? types : []).find(
      (t) => String(t.type_name || "").trim() === JOB_TYPE_REF_NAME,
    );
    if (!found) return [];
    const res = await API().get("/inspection/reference", {
      params: { type_id: found.id },
    });
    return Array.isArray(res.data) ? res.data : [];
  } catch {
    return [];
  }
}

export async function getRegister(params) {
  const response = await API().get("/high/register", {
    params: { ...params },
  });
  return response.data;
}

export async function postRegister(params) {
  const response = await API().post("/high/register", {
    yearc: params.yearc,
    type_id: params.type_id,
    // Олон ажлын төрөл (2–3) — сервер эхнийхийг үндсэн `type_id` болгоно
    type_ids: params.type_ids,
    department_code: params.department_code,
    department_name: params.department_name,
    jobdesc: params.jobdesc,
    comment: params.comment,
    matrix_id: params.matrix_id,
    start_date: params.start_date || null,
    end_date: params.end_date || null,
    usertn: params.usertn,
    // ── Наряд зөвшөөрлийн гүйцэд бүртгэл ──────────────────────────────
    // Эх сурвалж: ODOO.ERP «АЖЛЫН ЖАГСААЛТ» + Чухал хяналтын процесс.
    // Migration: Models/highrisk/alter_highrisk_permit.sql
    customer_code: params.customer_code || null,
    customer_name: params.customer_name || null,
    customer_section_code: params.customer_section_code || null,
    customer_section_name: params.customer_section_name || null,
    executor_type: params.executor_type || null,
    executor_code: params.executor_code || null,
    executor_name: params.executor_name || null,
    executor_section_code: params.executor_section_code || null,
    executor_section_name: params.executor_section_name || null,
    executor_org_name: params.executor_org_name || null,
    shift_count: params.shift_count ?? null,
    worker_count: params.worker_count ?? null,
    permit_giver_tn: params.permit_giver_tn || null,
    permit_giver_name: params.permit_giver_name || null,
    permit_giver_position: params.permit_giver_position || null,
    foreman_tn: params.foreman_tn || null,
    foreman_name: params.foreman_name || null,
    foreman_position: params.foreman_position || null,
    tech_card_no: params.tech_card_no || null,
    instruction_no: params.instruction_no || null,
    valid_from: params.valid_from || null,
    valid_to: params.valid_to || null,
  });
  return response.data;
}

export async function putRegister(id, params) {
  const response = await API().put("/high/register/" + id, {
    approve_id: params.approve_id,
    approve_comment: params.approve_comment,
  });
  return response.data;
}

export async function postExecution(params) {
  console.log(params);
  const response = await API().post("/high/execution", {
    job_id: params.job_id,
    comment: params.comment,
    execution: params.execution,
    usertn: params.usertn,
  });
  return response.data;
}

export async function getExecution(id) {
  const response = await API().get("/inspection/execution");
  return response.data;
}

export async function putExecution(id, params) {
  const response = await API().put("/inspection/execution/" + id, {
    ...params,
  });
  return response.data;
}

export async function getApprove(params) {
  const response = await API().get("/inspection/approve", {
    params: { ...params },
  });
  return response.data;
}

export async function postApprove(params) {
  const response = await API().post("/inspection/approve", {
    register_id: params.register_id,
    dt: params.dt,
    type_id: params.type_id,
    comment: params.comment,
    usertn: params.usertn,
  });
  return response.data;
}


// ── Нарядад хавсаргасан баримт (маягтын 3.3 «төсөл» / 3.4 «хэмжилт») ──
// 3.1 заавар ба 3.2 технологийн карт нь ТОНОГ ТӨХӨӨРӨМЖӨӨС автоматаар
// бөглөгддөг тул энд зөвхөн бодит БАРИМТ (файл) хавсаргана.
export async function listJobAttach(jobId) {
  const res = await API().get("/high/attach", { params: { job_id: jobId } });
  return res.data?.items || [];
}

export async function uploadJobAttach(jobId, file, name, kind) {
  const form = new FormData();
  form.append("file", file);
  form.append("job_id", jobId);
  form.append("name", name || "");
  form.append("kind", kind || "other");
  const res = await API().post("/high/attach", form, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 120000,
  });
  return res.data;
}

export async function deleteJobAttach(id) {
  const res = await API().delete("/high/attach/" + id);
  return res.data;
}

// ── §4 ХАРИУЦЛАГАТАЙ ИТА (HRT AT_Step4 × 5) ─────────────────────────────
// Зөвшөөрлийн хуудасны 4-р хэсэг: ажилд оруулагч · хариуцлагатай удирдагч ·
// ажил гүйцэтгэгч · зөвшөөрөл олгогч · ХАБЭА-н хяналтын инженер.

export async function getJobSignatures(jobId) {
  const res = await API().get("/xab/hr-signatures", {
    params: { job_id: jobId },
  });
  return res.data;
}

export async function addJobSignature(payload) {
  const res = await API().post("/xab/hr-signatures", payload);
  return res.data;
}

export async function updateJobSignature(payload) {
  const res = await API().put("/xab/hr-signatures", payload);
  return res.data;
}

export async function deleteJobSignature(id) {
  const res = await API().delete("/xab/hr-signatures", { params: { id } });
  return res.data;
}

// ── §7 УРЬДЧИЛАН СЭРГИЙЛЭХ АРГА ХЭМЖЭЭ (HRT AT_Step7 + Checks) ──────────
// Нарядад хамаарах шаардлагыг сонгож, ээлж бүрд ажилд оруулагч ба ажил
// гүйцэтгэгч ХОЁУЛАА тэмдэглэнэ — давхар баталгаа.

export async function getJobProvisions(jobId) {
  const res = await API().get("/xab/hr-job-provisions", {
    params: { job_id: jobId },
  });
  return res.data;
}

/** Сонголтыг БҮХЭЛД нь тохируулна (нэмэх/хасахыг сервер өөрөө бодно). */
export async function setJobProvisions(jobId, legacyIds) {
  const res = await API().post("/xab/hr-job-provisions", {
    job_id: jobId,
    legacy_ids: legacyIds,
  });
  return res.data;
}

/** Нэг нүд — шаардлага × ээлж × тал. */
export async function checkJobProvision(payload) {
  const res = await API().put("/xab/hr-job-provisions", payload);
  return res.data;
}

// ── §6 БРИГАД + ЗААВАРЧИЛГАА (HRT AT_Step6) ─────────────────────────────
// ⚠ Бүрэлдэхүүнийг ЭНД нэмэхгүй — ажилтан ӨЭА-д гарахаар бүртгүүлэхэд
//   `oea_worker_registrations`-д үүсдэг. Энэ нь «хэн зааварчилсан» давхарга.

export async function getJobBrigade(jobId) {
  const res = await API().get("/xab/hr-job-brigade", {
    params: { job_id: jobId },
  });
  return res.data;
}

export async function setJobBriefing(payload) {
  const res = await API().put("/xab/hr-job-brigade", payload);
  return res.data;
}

// ── §5 ӨДӨР ТУТМЫН ЭХЛЭЛ, ТӨГСГӨЛ (HRT AT_Step5) ────────────────────────
// Ээлж бүрд 4 гарын үсэг: нээх (оруулагч+гүйцэтгэгч), хаах (мөн хоёул).

export async function getJobShifts(jobId) {
  const res = await API().get("/xab/hr-job-shifts", { params: { job_id: jobId } });
  return res.data;
}

export async function addJobShift(payload) {
  const res = await API().post("/xab/hr-job-shifts", payload);
  return res.data;
}

/** Гарын үсэг зурах/цуцлах эсвэл огноо-ротаци засах. */
/** §2.2 Тусгаарлалт хийх ТТ — жагсаалт унших. */
export async function getJobIsolation(jobId) {
  const res = await API().get("/xab/hr-job-isolation", {
    params: { job_id: jobId },
  });
  return res.data;
}

/** §2.2 Тусгаарлалт хийх ТТ — БҮТНЭЭР солих. */
export async function setJobIsolation(payload) {
  const res = await API().put("/xab/hr-job-isolation", payload);
  return res.data;
}

export async function updateJobShift(payload) {
  const res = await API().put("/xab/hr-job-shifts", payload);
  return res.data;
}

export async function deleteJobShift(id) {
  const res = await API().delete("/xab/hr-job-shifts", { params: { id } });
  return res.data;
}

/**
 * Наряд ЗАСАХ — үндсэн талбарууд.
 *
 * ⚠ `putRegister` нь ЗӨВХӨН батламжийн (approve_id) зориулалттай тул
 *   түүнийг өөрчилвөл батламжийн урсгал эвдэрнэ. Тиймээс тусад нь.
 *
 * ⚠ ЯАГААД ХЭРЭГТЭЙ БОЛОВ: маягт нь засах үед ч `postRegister` дуудаж
 *   байсан тул наряд засах бүрд ШИНЭ мөр үүсэж ДАВХАРДАЛ бий болдог байв.
 */
export async function editRegister(id, params) {
  const response = await API().put("/high/register/" + id, params);
  return response.data;
}
